import { WidgetBase, SortType} from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { app } from "../../../Frame/App";
import { PopupMeasuresByStatusComponent } from "../Popups/PopupMeasuresByStatusComponent";
import { WidgetMeasuresByStatusComponent } from "../Components/WidgetMeasuresByStatusComponent";


export class WidgetMeasuresByStatusColumnFilter {
    templateBlockId: number;
    filter: string;
}

export class WidgetMeasuresByStatusProps {
    public markupHeader: string;
    public markupItems: string;
    public styles: string;
    public clientId: string;
    public rowClickLayoutId: number;
    public rowClickURL: string;
    public rowClickUrlUsePopup: boolean;
    public templateId: string;
    public additionalFilter: string;
    public columnFilters: WidgetMeasuresByStatusColumnFilter[] = [];
    public sortFirst: string;
    public sortFirstAsc: SortType;
    public sortSecond: string;
    public sortSecondAsc: SortType;
}
export class WidgetMeasuresByStatus extends WidgetBase {
    props: WidgetMeasuresByStatusProps;
    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetMeasuresByStatusProps();
        this.props.sortFirstAsc = SortType.desc;
        this.props.sortSecondAsc = SortType.desc;
    }

    getType(): WidgetTypes {
        return WidgetTypes.MeasuresByStatus;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (app.isNullOrUndefined(this.props.sortFirstAsc))
                this.props.sortFirstAsc = SortType.desc;
            if (app.isNullOrUndefined(this.props.sortSecondAsc))
                this.props.sortSecondAsc = SortType.desc;
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    showPopup(): void {
        let popup = new PopupMeasuresByStatusComponent({ widget: this });
        document.body.appendChild(popup.render());
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetMeasuresByStatusComponent({
            widget: this,
            markupHeader: this.props.markupHeader,
            markupItems: this.props.markupItems,
            styles: this.props.styles,
            clientId: this.props.clientId,
            rowClickLayoutId: this.props.rowClickLayoutId,
            rowClickURL: this.props.rowClickURL,
            rowClickUrlUsePopup: this.props.rowClickUrlUsePopup,
            templateId: this.props.templateId,
            additionalFilter: this.props.additionalFilter,
            columnFilters: this.props.columnFilters,
            sortFirst: this.props.sortFirst,
            sortFirstAsc: this.props.sortFirstAsc,
            sortSecond: this.props.sortSecond,
            sortSecondAsc: this.props.sortSecondAsc
        });
        return this.component.render();
    }
}